<template>
  <LayoutGradient :title="$t('rnds.show.title')" icon="fa-sign-out-alt">
    <template v-slot:headerRight>
      <b-btn variant="outline-info" @click="$router.back()">
        <i class="fas fa-arrow-left"/> {{ $t('sideBar.voltar') }}
      </b-btn>
    </template>
    <b-card class="m-3 mt-n10">
      <b-table :items="[transmissao]" :fields="fields" stacked>
        <template v-slot:cell(request)="{ item: { request }}">
          <pre>{{ JSON.parse(request) }}</pre>
        </template>
        <template v-slot:cell(response)="{ item: { response }}">
          <pre v-if="JSON.parse(response).header">{{ JSON.parse(response).header | nl2br }}</pre>
          <pre>{{ JSON.parse(response) }}</pre>
        </template>
        <template v-slot:cell(created_at)="{ item: { created_at }}">
          {{ created_at | formatDate }}
        </template>
        <template v-slot:cell(status)="{ item: { status }}">
          <span :class="{'rounded-pill p-1 ': true, 'badge badge-success': status === 'success', 'badge badge-danger': status === 'error'}">
            <i :class="status === 'success' ? 'fas fa-check' : 'fas fa-ban'"/>
          </span>
        </template>
      </b-table>
    </b-card>
  </LayoutGradient>
</template>

<script>
import {mapActions, mapGetters} from 'vuex'
import LayoutGradient from "@/templates/LayoutGradient";

export default {
  name: "Show",
  components: {LayoutGradient},
  computed: {
    ...mapGetters({
      transmissao: 'rnds/current',
      store_isLoading: 'rnds/isLoading'
    }),
    isLoading() {
      return !(this.mounted && this.store_isLoading === false)
    }
  },
  data() {
    return {
      mounted: false,
      fields: [
        {key: 'request', label: this.$t('rnds.listagem.table.transmissao')},
        {key: 'response', label: this.$t('rnds.listagem.table.resposta')},
        {key: 'message', label: this.$t('rnds.listagem.table.mensagem')},
        {key: 'created_at', label: this.$t('rnds.listagem.table.criadoem')},
        {key: 'status', label: 'Status'},
      ]
    }
  },
  methods: {
    ...mapActions([
      'rnds/listOne'
    ])
  },
  mounted() {
    this['rnds/listOne'](this.$route.params.id)
    this.mounted = true
  }
}
</script>

<style scoped>
::v-deep.table.b-table.b-table-stacked > tbody > tr > [data-label]::before{
  width: 25% !important;
}
::v-deep.table.b-table.b-table-stacked > tbody > tr > [data-label] > div{
  width: calc(100% - 25%) !important;
}
</style>